export default "__VITE_ASSET__Cgs8mjjN__"